import moment from 'moment';

const relativeTime = (timestampA, timestampB, hasAgo = true) => moment(timestampA).from(timestampB, !hasAgo);

const formatDate = (date, format) => moment(date).format(format);

export const timePlugin = {
    install(Vue) {
        Vue.prototype.$relativeTime = relativeTime;
        Vue.prototype.$formatDate = formatDate;
    },
};
